import {auth} from 'main/tools';

export const policiesRootPath = () => auth.featureEnabled(':time_tracking_dimensions') ? '/policies' : '/manage';

export const policiesRootUrl = () => `/time_tracking${policiesRootPath()}`;
